module.exports = __webpack_public_path__ + "img/article.93ea5611.png";